import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface ISaleAgentsSelectedLocation {
  location?: string[];
  name?: string;
}

export interface IsaleAgentsSelectedLocation {
  selectedLocation: ISelected;
}

const initialState: ISaleAgentsSelectedLocation = {};

export const saleAgentsLocationSlice = createSlice({
  name: 'saleAgentsLocation',
  initialState,
  reducers: {
    addAddress: (state, action: PayloadAction<ISaleAgentsSelectedLocation>) => {
      state.location = action.payload.location;
      state.name = action.payload.name;
    },
    clearAddress: state => {
      state.location = [];
      state.name = '';
    },
  },
});

export const {addAddress, clearAddress} = saleAgentsLocationSlice.actions;

export default saleAgentsLocationSlice.reducer;
